module.exports = __webpack_public_path__ + "img/main_mockup_attendance.aff72ba7.png";